import PropTypes from 'prop-types';
var propTypes = {
  component: PropTypes.elementType,
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  leadingArea: PropTypes.node,
  role: PropTypes.string,
  trailingArea: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
export default propTypes;